//上传cos配置
export const upConfig = {
    Bucket: 'fayuxingwei-1316488073',
    Region: 'ap-nanjing'
}
//上传目录
export const upDir = 'fayuxingwei'
